import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import MobileSheet from "./MobileSheet";
import ButtonListContext from "@widget/buttons/ButtonListContext";
/**
 * @export
 * A bottom sheet with an item's actions, one labelled row each. Buttons passed in become rows
 * (an icon-only button shows its tooltip as the label). The sheet closes when a row is tapped,
 * before the action runs, so a confirm or form the action opens shows on its own.
 * SwipeActions, TreeView nodes and table rows use it on touch screens.
 *
 * @example
 * ```tsx
 * <ActionsSheet isOpen={open} onClose={() => setOpen(false)} title={item.name}>
 *     <ButtonComponent title="Edit" leftIcon="phr pencil-simple" onClick={edit} />
 *     <ButtonComponent title="Delete" leftIcon="phr trash" variant="danger" onClick={remove} />
 * </ActionsSheet>
 * ```
 *
 * @category Overlays
 */
const ActionsSheet = ({ isOpen, onClose, title, children }) => {
    const listMode = useMemo(() => ({ onAction: onClose }), [onClose]);
    return _jsx(MobileSheet, { isOpen: isOpen, onClose: onClose, title: title, children: _jsx(ButtonListContext.Provider, { value: listMode, children: _jsx("div", { className: "uxpcore_sheetlist", children: children }) }) });
};
export default ActionsSheet;
